module.exports = __webpack_public_path__ + "img/fin_12_拥抱相片.4b6763b8.jpg";